const PHONE_NUMBERS = {
  DEFAULT: 6468590828,
  TRAFFIC_LOOKUP: {
    CAL: 3103625473,
    CAL_STATE: 3103625473,
    CAL_ORANGE: 3103625473,
    CAL_SAN_BERNARDINO: 3103625473,
    CAL_SANTA_BARBARA: 3103625473,
    CAL_SANTA_CLARA: 3103625473,
    CAL_SAN_FRANCISCO: 3103625473,
    CAL_SAN_DIEGO: 3103625473,
    CAL_VENTURA: 3103625473,
    FL_MIAMI: 7862448344,
    GA: 4706644240,
    NJ: 5512135851,
    NY: 6463744329,
    NY_HEMPSTEAD: 5166045711,
    NY_NASSAU: 5166045711,
    PA_PHILADELPHIA: 2677562216,
    TX_AUSTIN: 7372739991,
    WA: 2066812110,
    WA_NEW_SEATTLE: 2066812110,
    WA_SEATTLE_2: 2066812110,
    NC: 9842999984,
    CAL_SAN_JOAQUIN: 3103625473,
  },
  TRAFFIC_FLOW: {
    CA: 3109430693,
    FL: 7862448594,
    GA: 4706644240,
    NJ: 5512135851,
    NY: 6463744329,
    TX: 5123597469,
    PA: 5706349090,
    WA: 2066812110,
    NC: 9842999984
  },
}

export const SUPPORT_PHONE_NUMBER = {
  number: "+18888394648",
  displayNumber: "1-888-83-WINIT",
  rawDisplayNumber: "1-888-839-4648",
}

export const SUPPORT_PHONE_NUMBER_WL = {
  number: "+18885994648",
  displayNumber: "1-888-59-WINIT",
  rawDisplayNumber: "1-888-599-4648",
}

export default PHONE_NUMBERS
